import { render, staticRenderFns } from "./NewRequestTargetedGrantView.vue?vue&type=template&id=3902f4a0"
import script from "./NewRequestTargetedGrantView.vue?vue&type=script&lang=js"
export * from "./NewRequestTargetedGrantView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports